<div class="header-navigation-wrapper">
  <div id="welcome-wrapper">
    <h2 id="hello-text">
      <div class="desktop">Bonjour {{patient.firstName | capitalize}}, ravi de vous revoir 👋</div>
    </h2>
    <div class="actions-wrapper">

      <div class="dropdown" dropdown #dropdown="bs-dropdown" (click)="$event.stopPropagation()">
        <button [class.badged]="notifications && notifications.length > 0"
                class="notifications-button btn btn-outline-primary btn-outline icon-only"
                dropdownToggle type="button">
          <ng-container *ngIf="isLoadingNotifications else notificationsButton">
            <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
            <span class="visually-hidden">Chargement...</span>
          </ng-container>
          <ng-template #notificationsButton>
            <i class="iconly-Notification"></i>
          </ng-template>
        </button>
        <div class="dropdown-backdrop fade" (click)="dropdown.hide()"></div>
        <ul *dropdownMenu role="menu" class="dropdown-menu dropdown-menu-right dropdown-notification">
          <ng-container *ngIf="notifications && notifications.length > 0; else emptyTemplate">
            <li (onMarkAsRead)="markAsRead(notification)"
                (onAdditionalButton)="openNotification($event); dropdown.hide();"
                *ngFor="let notification of notifications"
                [additionalPayload]="notification.payload"
                [additionalButton]="getAdditionalButton(notification)"
                [content]="getContent(notification)"
                [date]="notification.createdAt"
                [loading]="notification === markingAsReadNotification"
                [title]="getTitle(notification)"
                class="notification-cell"
                msd-notification-cell></li>
            <li style="text-align: center;">
              <button type="button" class="btn btn-link mark-as-read-button" (click)="markAsReadAll()">
                <ng-container *ngIf="loadingMarkAsReadAll else markAsReadTemplate">
                  <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                  <span class="visually-hidden">Chargement...</span>
                </ng-container>
                <ng-template #markAsReadTemplate>
                  Marquer tout comme lu
                </ng-template>
              </button>
            </li>
          </ng-container>
          <ng-template #emptyTemplate>
            <li class="empty-notification-label">Aucune notification 🎉</li>
          </ng-template>
        </ul>
      </div>

      <button (click)="openMyAccount()"
              class="add-patient-button btn btn-primary btn-gradient"
              type="button">
        <span class="mr10px">Mon compte</span>
        <i i-bs name="person-circle" width="20" height="20"></i>
      </button>

    </div>
  </div>

  <msd-segmented-navigation #tabs [items]="segmentedItems"></msd-segmented-navigation>
</div>
